class Components {
    constructor() {
        this.components = [
            //Lazy loaded components. Components that are not 'above the fold'
            {
                element: ".js-service-menu",
                name: "HeaderServiceMenu",
                lazyLoad: async () => (await import(/* webpackChunkName: "header-service-menu" */ "./header/header-service-menu")).default
            },
            {
                element: ".js-top-menu",
                name: "HeaderTopMenu",
                lazyLoad: async () => (await import(/* webpackChunkName: "header-top-menu" */ "./header/header-top-menu")).default
            },
            {
                element: ".ce-documents-section",
                name: "CeDocuments",
                lazyLoad: async () => (await import(/* webpackChunkName: "ce-documents" */ "./ce-documents/ce-documents")).default
            },
            {
                element: ".slideshow",
                name: "Slideshow",
                lazyLoad: async () => (await import(/* webpackChunkName: "slideshow" */ "./slideshow/slideshow")).default
            },
            {
                element: ".fade-slideshow",
                name: "FadeSlideshow",
                lazyLoad: async () => (await import(/* webpackChunkName: "face-slideshow" */ "./fade-slideshow/fade-slideshow")).default
            },
            {
                element: ".js-map",
                name: "Map",
                lazyLoad: async () => (await import(/* webpackChunkName: "map" */ "./map/map")).default
            },
            {
                element: "[js-gallery-popover]",
                name: "GalleryPopover",
                lazyLoad: async () => (await import(/* webpackChunkName: "gallery-popover" */ "./gallery/gallery-popover")).default
            },
            {
                element: "[js-gallery-loadmore]",
                name: "GalleryLoadmore",
                lazyLoad: async () => (await import(/* webpackChunkName: "gallery-loadmore" */ "./gallery/gallery-loadmore")).default
            },
            {
                element: ".accordion.menu",
                name: "Accordion",
                lazyLoad: async () => (await import(/* webpackChunkName: "accordion" */ "./accordion/accordion")).default
            },
            {
                element: ".js-form",
                name: "Forms",
                lazyLoad: async () => (await import(/* webpackChunkName: "form" */ "./form/form")).default
            },
            {
                element: "[js-combobox-filter]",
                name: "Combobox",
                lazyLoad: async () => (await import(/* webpackChunkName: "combobox" */ "./form/combobox")).default
            },
            {
                element: "[js-select]",
                name: "Select",
                lazyLoad: async () => (await import(/* webpackChunkName: "combobox-select" */ "./form/combobox")).default
            },
            {
                element: ".col-left .accordion.menu",
                name: "LeftMenu",
                lazyLoad: async () => (await import(/* webpackChunkName: "left-menu" */ "./left-menu/left-menu")).default
            },
            {
                element: ".social-panel",
                name: "SocialPanel",
                lazyLoad: async () => (await import(/* webpackChunkName: "social-panel" */ "./social-panel/social-panel")).default
            },
            {
                element: ".buttons.social-panel-mobile",
                name: "SocialPanel",
                lazyLoad: async () => (await import(/* webpackChunkName: "social-panel" */ "./social-panel/social-panel")).default
            },
            {
                element: ".ui.expadable-content",
                name: "ExpandableContent",
                lazyLoad: async () => (await import(/* webpackChunkName: "expandable-content" */ "./expandable-content/expandable-content")).default
            },
            {
                element: ".js-reused",
                name: "Reused",
                lazyLoad: async () => (await import(/* webpackChunkName: "reused" */ "./reused/reused")).default
            },
            {
                element: ".lightbox",
                name: "Lightbox",
                lazyLoad: async () => (await import(/* webpackChunkName: "lightbox" */ "./lightbox/lightbox")).default
            },
            {
                element: ".adaptive-lightbox",
                name: "Adaptive-Lightbox",
                lazyLoad: async () => (await import(/* webpackChunkName: "lightbox" */ "./lightbox/lightbox")).default
            },
            {
                element: ".expandable-content-large",
                name: "ExpandableContentLarge",
                lazyLoad: async () => (await import(/* webpackChunkName: "expandable-content-large" */ "./expandable-content-large/expandable-content-large")).default
            },
            {
                element: ".floating-image-listing-block",
                name: "FloatingImageListingBlock",
                lazyLoad: async () => (await import(/* webpackChunkName: "floating-image-listing-block" */ "./floating-image-listing-block/floating-image-listing-block")).default
            },
            {
                element: ".footer__search",
                name: "FooterSearch",
                lazyLoad: async () => (await import(/* webpackChunkName: "footer-search" */ "./footer/footer-search")).default
            },
            {
                element: ".vacant-jobs-new",
                name: "VacantJobs",
                lazyLoad: async () => (await import(/* webpackChunkName: "vacant-jobs" */ "./vacant-jobs/vacant-jobs")).default
            },
            {
                element: ".chart-block",
                name: "ChartBlock",
                lazyLoad: async () => (await import(/* webpackChunkName: "chart-block" */ "./chart-block/chart-block")).default
            },
            {
                element: ".image-comparison",
                name: "ImageComparison",
                lazyLoad: async () => (await import(/* webpackChunkName: "image-comparison" */ "./image-comparison/image-comparison")).default
            },
            {
                element: ".calendar-block",
                name: "CalendarBlock",
                lazyLoad: async () => (await import(/* webpackChunkName: "calendar-block" */ "./calendar-block/calendar-block")).default
            },
            {
                element: ".strategic-direction",
                name: "StrategicDirection",
                lazyLoad: async () => (await import(/* webpackChunkName: "strategic-direction" */ "./strategic-direction/strategic-direction")).default
            },
            {
                element: ".download-center",
                name: "DownloadCenter",
                lazyLoad: async () => (await import(/* webpackChunkName: "download-center" */ "./download-center/download-center")).default
            },
            {
                element: ".project-side-scroller",
                name: "ProjectSideScroller",
                lazyLoad: async () => (await import(/* webpackChunkName: "project-side-scroller" */ "./project-side-scroller/project-side-scroller")).default
            },
            {
                element: ".AnnualReportPage",
                name: "AnnualReport",
                lazyLoad: async () => (await import(/* webpackChunkName: "annual-report" */ "./annual-report-page/annual-report")).default
            },
            {
                element: ".navbar-language",
                name: "AnnualReportSelect",
                lazyLoad: async () => (await import(/* webpackChunkName: "annual-report-select" */ "./annual-report-select/annual-report-select")).default
            },
            {
                element: ".srApplyLink",
                name: "SrApplyLink",
                lazyLoad: async () => (await import(/* webpackChunkName: "sr-apply-link" */ "./sr-apply-link/sr-apply-link")).default
            }
        ];
    }

    async load() {
        for (var i in this.components) {
            await this.checkComponent(this.components[i], function (component) {
                $(component.element).each(function (key, item) {
                    let el = $(item);
                    var name = component.name;

                    var modules = el.data("modules") || {};

                    console.info("Loading module '%s' and attaching to '%s'", name, component.element);

                    if (!modules.hasOwnProperty(name)) {
                        var m = new component.component(el);
                        modules[name] = m;
                        el.data("modules", modules);
                    }
                });
            });
        }
        console.log("components loaded...");
    }

    async checkComponent(component, callback) {
        const elementExists = !!$(component.element).length;
        const isLazyLoaded = component.hasOwnProperty("lazyLoad");
        if (isLazyLoaded && elementExists) {
            const lazyLoadedComponent = await component.lazyLoad();
            component.component = lazyLoadedComponent;
        } else if (isLazyLoaded && !elementExists) {
            if (process.env.NODE_ENV !== 'production')
                console.debug(component.name + "'s element is not present in markup won't lazy load component.");
            return;
        }

        if (
            !component.hasOwnProperty("element") ||
            !component.hasOwnProperty("component")
        ) {
            if (!component.hasOwnProperty("component")) {
                console.warn("Component:", component);
                throw new Error("Trying to load component without component specified");
            }

            if (!component.hasOwnProperty("element")) {
                console.warn("Component:", component);
                throw new Error("Trying to load component without element");
            }
        }

        callback(component);
    }
}

export default Components;
